import React from 'react'
import './News.scss'
import NewsTitle from './NewsTitle/NewsTitle'
import NewsBottomCard from './NewsBottomCard/NewsBottomCard'
import NewsSkeleton from './NewsSkeleton/NewsSkeleton'

/*
  status: loading — ответа ещё нет и кэша не было, рисуем скелетон;
          error   — запрос не удался и показать нечего;
          ready   — есть список (из кэша или из сети).
*/
const News = ({ newsData, status = 'ready' }) => {
  const hasNews = Array.isArray(newsData) && newsData.length > 0;

  return (
    <div className='news_container'>
      <div className="news_block">
        <NewsTitle/>
        {hasNews
          ? newsData.map((e) => <NewsBottomCard newsData={e} key={e.id} />)
          : status === 'loading'
            ? <NewsSkeleton />
            : <p className="news_empty">Новости скоро появятся</p>}
      </div>
    </div>
  )
}

export default News
